import {
  AlertTriangle,
  CheckCircle,
  CheckCircle2,
  CloudUpload,
  Cross,
  Eye,
  EyeOff,
  FileText,
  IndianRupee,
  Loader2,
  ShieldCheck,
  Store,
  Trash2,
  UploadCloudIcon,
  Users,
  X,
  XCircle,
} from "lucide-react";

import { KpiCard } from "../../../Component/AdminComponents/KpiCard";
import { SectionCard } from "../../../Component/AdminComponents/SectionCard";
import { Badge } from "../../../Component/AdminComponents/Badge";
import { formatCurrency } from "../../../Component/AdminComponents/formatCurrency";
import { useNavigate } from "react-router-dom";
import { ValueLoader } from "../../../Component/Common/ValueLoader";
import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../../config/api";

export default function OverviewView({ stats, loading }) {
  const navigate = useNavigate();

  const [retailerLineStats, setRetailerLineStats] = useState(null);
  const [lineLoading, setLineLoading] = useState(false);
  

  const fetchRetailerLineChart = async () => {
    try {
      setLineLoading(true);

      const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");
      const role = Number(authUser?.role);
      const companyId = authUser?.id;

      const params = {};
      if (role === 2 && companyId) params.company_id = companyId;

      const res = await axios.get(
        `${BASE_URL}company/employee-retailer-line-chart`,
        { params }
      );

      if (res.data?.success) {
        setRetailerLineStats(res.data.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLineLoading(false);
    }
  };

  useEffect(() => {
    fetchRetailerLineChart();
  }, []);
  
  return (
    <div className="space-y-4">
      {/* KPI Grid */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3">

        <KpiCard
          label="Agents"

          value={loading ? <ValueLoader /> : stats.agentCount}
          subLabel="Field & onboarding"
          icon={Users}
          onClick={() => navigate("/admagents")}
          className="cursor-pointer"   // optional 
        />

        <KpiCard
          label="Retailers"
          value={loading ? <ValueLoader /> : stats.retailerCount}
          subLabel={`Active: ${stats.activeRetailers} Retailer Using platform`}
          icon={Store}
          onClick={() => navigate("/admretailers")}
          className="cursor-pointer"   // optional to show pointer UI
        />

        <KpiCard
          label="Employees"
          value={loading ? <ValueLoader /> : stats.CompanyEmployee}
          subLabel={`Active: ${stats.CompanyEmployee}`}
          icon={Store}
          onClick={() => navigate("/allemployees")}
          className="cursor-pointer"   // optional to show pointer UI
        />

        <KpiCard
          label="Products"
          value={loading ? <ValueLoader /> : stats.productCount}
          subLabel="Product Created"
          icon={Store}
          onClick={() => navigate("/products")}
          className="cursor-pointer"   // optional to show pointer UI
        />

        <KpiCard
          label="Price Template"
          value={loading ? <ValueLoader /> : stats.priceTemplates}
          subLabel="All Price Template"
          icon={Store}
          onClick={() => navigate("/pricetemplate")}
          className="cursor-pointer"   // optional to show pointer UI
        />

        <KpiCard
          label="Connected"
          value={loading ? <ValueLoader /> : stats.connectedRetailers}
          subLabel=""
          icon={CheckCircle2}
          onClick={() =>
            navigate("/admretailers", { state: { filterStatus: "Connected" } })
          }
        />

       <KpiCard
          label="Active Warranties"
          value={loading ? <ValueLoader /> : stats.activeWarranties}
          subLabel={`Total: ${stats.total_warranties_count}`}
          icon={ShieldCheck}
          onClick={() =>
            navigate("/admwrnty", {
              state: { activeTab: "warranties" }, // 👈 KEY
            })
          }
        />

        <KpiCard
          label="Open Claims"
          value={loading ? <ValueLoader /> : stats.openClaims}
          icon={FileText}
          onClick={() =>
            navigate("/admwrnty", {
              state: { activeTab: "claims" }, // 👈 KEY
            })
          }
        />

        <KpiCard
          label="Approved Commission"
          value={`₹ ${formatCurrency(stats.approved_commission)}`}
          subLabel={`Pending: ₹ ${formatCurrency(stats.pending_commission)}`}
          icon={IndianRupee}
        />

       {/* <KpiCard
        label="Template Images"
        value="Upload"
        subLabel={`upload images for templates`}
        icon={UploadCloudIcon}
        onClick={() => setOpenUploadModal(true)}
      /> */}
      </div>
      

      {/* Summary Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-2">
        {/* <SectionCard
          title="Retailer Health Snapshot"
          right={
            <span className="hidden md:inline text-[11px] text-slate-400">
              Based on connection & usage
            </span>
          }
        >
          <div className="text-xs space-y-3">
            <div className="flex justify-between items-center">
              <span className="text-slate-600">Connected retailers</span>
              <span className="font-semibold text-blue-700">
                {stats.connectedRetailers} / {stats.totalRetailers}
              </span>
            </div>
            <div className="w-full bg-slate-100 rounded-full h-2 overflow-hidden">
              <div
                className="h-2 bg-blue-500 rounded-full"
                style={{
                  width: `${
                    stats.totalRetailers
                      ? (stats.connectedRetailers / stats.totalRetailers) * 100
                      : 0
                  }%`,
                }}
              />
            </div>
            <p className="text-[11px] text-slate-500">
              Track which retailers are activated, connected to APIs, using the app
              for sales, warranties, and claims.
            </p>
          </div>
        </SectionCard> */}

        <SectionCard
          title="Retailer Health Snapshot"
          right={
            <span className="hidden md:inline text-[11px] text-slate-400">
              Based on connection & usage
            </span>
          }
        >
          <div className="text-xs space-y-3">
            {lineLoading || !retailerLineStats ? (
              <ValueLoader />
            ) : (
              <>
                <div className="flex justify-between items-center">
                  <span className="text-slate-600">Connected retailers</span>
                  <span className="font-semibold text-blue-700">
                    {retailerLineStats.connected.count} /{" "}
                    {retailerLineStats.connected.total}
                  </span>
                </div>

                <div className="w-full bg-slate-100 rounded-full h-2 overflow-hidden">
                  <div
                    className="h-2 bg-blue-500 rounded-full"
                    style={{
                      width: `${retailerLineStats.connected.percent}%`,
                    }}
                  />
                </div>

                <p className="text-[11px] text-slate-500">
                  Retailers who have successfully connected and are actively using the
                  platform services.
                </p>
              </>
            )}
          </div>
        </SectionCard>


        <SectionCard
          title="Claims & Warranty Flow"
          right={
            <Badge color="yellow">
              <AlertTriangle className="w-3 h-3 mr-1" />
              Monitoring
            </Badge>
          }
        >
          <div className="text-xs space-y-2">
            <p className="text-slate-600">
              Combined view of retailer portal, retailer user portal and customer
              portal flows:
            </p>
            <ul className="list-disc list-inside space-y-1 text-slate-600">
              <li>
                Retailer sells warranty (from retailer dashboard), mapped to device
                IMEI & invoice.
              </li>
              <li>
                Customer or retailer raises claim (customer portal / retailer user
                portal).
              </li>
              <li>
                Ops & admin approve / reject with reasons (payment not paid, wrong
                product info / price, out of coverage etc.).
              </li>
              <li>
                Pickup / drop is arranged via channel partner, device goes to
                service centre and claim is settled.
              </li>
            </ul>
          </div>
        </SectionCard>

        <SectionCard
          title="Commission & Earnings"
          right={
            <Badge color="green">
              <CheckCircle2 className="w-3 h-3 mr-1" />
              Weekly cycle
            </Badge>
          }
        >
          <div className="text-xs space-y-2">
            <p className="text-slate-600">
              Commission generated from retailer warranty sales and onboarding by
              agents is combined and settled weekly.
            </p>
            <ul className="list-disc list-inside text-slate-600 space-y-1">
              <li>Agent-wise earnings (onboarding + performance).</li>
              <li>Retailer wise earnings (per warranty & sales volume).</li>
              <li>Transfer status with bank details, transaction ID & date.</li>
              <li>Downloadable weekly/monthly statements for audit.</li>
            </ul>
          </div>
        </SectionCard>
      </div>

      
    </div>
  );
}


/* ===============================
   IMAGE UPLOAD MODAL
================================ */

